import { z } from "zod";
import type { TFunction } from "i18next";

export const createRateSchema = (t: TFunction, roles: any[]) =>
    z.object({
        role: z.string().min(1, t("required-role")),
        maxRate: z.union([z.string(), z.number()]).optional(),
        maxAmount: z.union([z.string(), z.number()]).optional(),
    }).superRefine((data, ctx) => {
        if (!data.maxAmount) {
            ctx.addIssue({ code: z.ZodIssueCode.custom, message: t("required-max-amount"), path: ["maxAmount"] });
        } else if (Number(data.maxAmount) <= 0) {
            ctx.addIssue({ code: z.ZodIssueCode.custom, message: t("max-amount-pattern"), path: ["maxAmount"] });
        }

        const role = roles?.find((r: any) => r.id === data.role);
        const canUpdateRate = role?.permissions?.timeSheet?.canUpdateRate;
        if (canUpdateRate) {
            if (!data.maxRate) {
                ctx.addIssue({ code: z.ZodIssueCode.custom, message: t("required-max-rate"), path: ["maxRate"] });
            } else if (Number(data.maxRate) <= 0) {
                ctx.addIssue({ code: z.ZodIssueCode.custom, message: t("max-rate-pattern"), path: ["maxRate"] });
            }
        }
    });

export type RateFormValues = z.infer<ReturnType<typeof createRateSchema>>;
